<template>
  <div>
    <div class="pollContentContainer">
      <div class="headerText">Audience polls</div>
      <div
        class="singlePoll"
        v-for="(poll, index) in data"
        :key="index"
        @click="pollClicked(poll.title,poll.navigateTime?convertHoursMinsSecsToSeconds(poll.navigateTime):poll.parsedStart)"
      >
        <div class="textContainer">
          <div class="titleText">
            {{ poll.title }}
          </div>
          <div class="timeText">
            {{ poll.startTime }}  <span v-if="!poll.isActive">({{ poll.timeDifference }})</span><span v-if="poll.isActive">({{ poll.remainingTime }})</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import "../scss/poll-content.css";
import Vue from 'vue'
import pollClikcedMixin from '../mixins/pollClickedMixin'
import timeMixin from '../mixins/timeMixin'

export default {
  props: {
    data: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      isLoaded: false,
    };
  },
  created() {
    this.data.forEach((element) => {
      element.parsedStart = this.convertHoursMinsSecsToSeconds(element.startTime);
      element.parsedEnd = this.convertHoursMinsSecsToSeconds(element.endTime);
      Vue.set(element, "remainingTime", "");
      Vue.set(element, "timeDifference", this.convertSecondsToHourMinsSecs(element.parsedEnd-element.parsedStart));
      Vue.set(element, "isActive", false);
    });
  },
  methods: {
    swipeHandler(){
      console.log("swipeup")
    },
    runFirstLoad() {
    },
    process(time) {
      this.data.forEach(element => {
        if(time>element.parsedStart&&time<element.parsedEnd){
          element.isActive=true;
          element.remainingTime=this.convertSecondsToHourMinsSecs(element.parsedEnd-time)
        }
        else{
          element.isActive=false;
        }
      });
    },
  },
  mixins:[pollClikcedMixin, timeMixin]
};
</script>
